export const COUNTRIES = [
    {US: "United States"}
];